import i18n from 'i18next';

export const contactHistoryColumns = [
  {
    id: 'startDate',
    numeric: false,
    disablePadding: false,
    label: i18n.t('paymentInformation.start'),
  },
  {
    id: 'endDate',
    numeric: false,
    disablePadding: false,
    label: i18n.t('paymentInformation.end'),
  },
  {
    id: 'noOfDays',
    numeric: true,
    disablePadding: false,
    label: i18n.t('paymentInformation.noOfDays'),
  },

  {
    id: 'tier',
    numeric: false,
    disablePadding: false,
    label: i18n.t('registration.subscriptionTier'),
  },
];

export const compoentColumns = [
  {
    id: 'paymentId',
    numeric: true,
    disablePadding: false,
    label: i18n.t('paymentInformation.paymentId'),
    needSorting: true,
  },
  {
    id: 'createdDate',
    numeric: false,
    disablePadding: false,
    label: i18n.t('paymentInformation.createdDate'),
    needSorting: true,
  },
  {
    id: 'paymentDate',
    numeric: false,
    disablePadding: false,
    label: i18n.t('paymentInformation.paidDate'),
    needSorting: true,
  },
  {
    id: 'description',
    numeric: false,
    disablePadding: false,
    label: i18n.t('Description'),
    needSorting: true,
  },

  {
    id: 'truckCount',
    numeric: true,
    disablePadding: false,
    label: i18n.t('paymentInformation.unitCount'),
    needSorting: true,
  },
  {
    id: 'costPerTruck',
    numeric: true,
    disablePadding: false,
    label: i18n.t('paymentInformation.cost'),
    needSorting: true,
  },
  {
    id: 'amount',
    numeric: true,
    disablePadding: false,
    label: i18n.t('common.total'),
    needSorting: true,
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: i18n.t('paymentInformation.status'),
    needSorting: true,
  },
  {
    id: 'receipt',
    numeric: false,
    disablePadding: false,
    label: i18n.t('paymentInformation.receipt'),
    needSorting: true,
  },
];

export const paymentFields = [
  { label: i18n.t('paymentInformation.company'), valueKey: 'companyName' },
  { label: i18n.t('paymentInformation.nextBilling'), valueKey: 'nextBillingDate' },
  { label: i18n.t('paymentInformation.startDate'), valueKey: 'contractStartDate' },
  { label: i18n.t('registration.subscriptionTier'), valueKey: 'subscriptionTier' },
  { label: i18n.t('paymentInformation.contractLength'), valueKey: 'contractLength' },
];
